import React from 'react';
import kebabCase from 'lodash/kebabCase';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import Carousel from 'tbk-components/src/components/Carousel';
import CarouselItem from 'tbk-components/src/components/CarouselItem';
import Blockquote from 'tbk-components/src/components/Blockquote';

export interface ITestimonial {
	/**
	 * Testimonial Text
	 * @control textarea
	 */
	text?: string;
	/**
	 * Testimonial Author
	 */
	author?: string;
}

export interface ITestimonialsCarouselProps extends IBaseElementProps {
	testimonials?: ITestimonial[];
	/**
	 * Testimonial Carousel Color Select
	 */
	backgroundColor?: 'Blue' | 'Orange';
}

/**
 * Testimonials Carousel
 * @block
 * @requiresHooks
 * @icon align-center
 */
const TestimonialsCarousel: React.FC<ITestimonialsCarouselProps> = ({
	testimonials,
	backgroundColor = 'blue',
	className,
	classNames = [],
}) => (
	<div
		className={
			className ||
			cn(
				'testimonials-carousel',
				`testimonials-carousel-${kebabCase(backgroundColor)}`,
				...classNames,
			)
		}
	>
		<Carousel id="testimonials-carousel">
			{(testimonials || []).map(({ text, author }, index) => (
				<CarouselItem key={index}>
					<Blockquote source={author}>{text}</Blockquote>
				</CarouselItem>
			))}
		</Carousel>
	</div>
);

export default TestimonialsCarousel;
